import { Col, Row } from 'antd'
import classNames from 'classnames'
import React from 'react'

import styles from './generatedPalette.module.css'

interface Props {
  type: 'primary' | 'secondary'
  reversed?: boolean
}

export const GeneratedPalette: React.FC<Props> = ({ type, reversed }) => (
  <>
    {reversed && (
      <Row style={{ marginBottom: 2 }}>
        <Col>
          <p style={{ fontSize: 12 }}>Your color palette was generated automatically</p>
        </Col>
      </Row>
    )}

    <Row style={{ marginBottom: reversed ? 0 : 2 }}>
      <Col>
        <div
          className={classNames(
            styles.container,
            type === 'primary' ? styles.container_primary : styles.container_secondary,
          )}
        >
          <div className={styles.item} />
          <div className={styles.item} />
          <div className={styles.item} />
        </div>
      </Col>
    </Row>

    {/*{!reversed && (*/}
    {/*  <Row>*/}
    {/*    <Col>*/}
    {/*      <p style={{ fontSize: 12}}>*/}
    {/*        Your color palette was generated automatically*/}
    {/*      </p>*/}
    {/*    </Col>*/}
    {/*  </Row>*/}
    {/*)}*/}
  </>
)
